import React from "react";
import Button from "./Button";

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  children,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "primary",
  showCancel = true,
  isLoading = false,
  size = "md",
  hideCloseButton = false,
  backdropClassName = "",
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-xl",
    lg: "max-w-3xl",
    xl: "max-w-5xl",
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/35 backdrop-blur-[2px] px-4 py-6 ${backdropClassName}`}
      onClick={handleBackdropClick}
    >
      <div
        className={`w-full ${sizeClasses[size] || sizeClasses.md} max-h-[90vh] overflow-y-auto rounded-xl bg-white p-6 shadow-2xl`}
      >
        {/* Header */}
        {title && (
          <div className="mb-4 flex items-start justify-between">
            <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
            {!hideCloseButton && (
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
                aria-label="Close"
              >
                <svg
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
        )}

        {/* Content */}
        <div className="mb-6">
          {message && <p className="text-sm text-slate-600">{message}</p>}
          {children}
        </div>

        {/* Actions */}
        {onConfirm && (
          <div className="flex justify-end gap-3">
            {showCancel && (
              <Button
                type="button"
                variant="secondary"
                size="md"
                onClick={onClose}
                disabled={isLoading}
              >
                {cancelText}
              </Button>
            )}
            <Button
              type="button"
              variant={confirmVariant}
              size="md"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : confirmText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
